export default {
  profileTitle: "PROFILE_TITLE",
  manager: "MANAGER",
  managerAdmin: "MANAGER_ADMIN",
  tenant: "TENANT",
  owner: "OWNER",
  independentContractor: "INDEPENDENT_CONTRACTOR",
  caretaker: "CARETAKER",
  internalContractor: "INTERNAL_CONTRACTOR",
  salesperson: "SALESPERSON",
  customer: "CUSTOMER",
  administrator: "ADMINISTRATOR",
  account: "ACCOUNT",
  notificationParameters: "NOTIFICATION_PARAMETERS",
  notificationDetails: "NOTIFICATION_DETAILS",
  profileUpdated: "PROFILE_UPDATED",
  preferenceUpdated: "PREFERENCE_UPDATED",
  notificationParametersUpdated: "NOTIFICATION_PARAMETERS_UPDATED",
  rewritePassword: "REWRITE_PASSWORD",
  newPassword: "NEW_PASSWORD",
  globalNotifications: "GLOBAL_NOTIFICATIONS",
  contactInformations: "CONTACT_INFORMATIONS",
  app: "APP",
  email: "EMAIL",
  sms: "SMS",
  disableAppNotifications: "DISABLE_APP_NOTIFICATIONS",
  disableEmailNotifications: "DISABLE_EMAIL_NOTIFICATIONS",
  disableSmsNotifications: "DISABLE_SMS_NOTIFICATIONS",
  ticket: "TICKET",
  intervention: "INTERVENTION",
  event: "EVENT",
  rp: "RP",
  detail: "DETAIL",
  sucess: "SUCCESS",
  members_headers: {
    fullname: "MEMBER_FULLNAME",
    email: "MEMBER_EMAIL",
    tel_fix: "MEMBER_TEL_FIX",
    tel_portable: "MEMBER_TEL_PORTABLE",
    role: "MEMBER_ROLE"
  },
  profileMemberCreate: "PROFILE_MEMBER_CREATE",
  profileMemberUpdate: "PROFILE_MEMBER_UPDATE",
  profileOwnUpdate: "PROFILE_OWN_UPDATE",
  profileBtnRecord: "PROFILE_BTN_RECORD",
  profileCreateAnother: "PROFILE_CREATE_ANOTHER",
  profileCivilityMale: "PROFILE_CIVILITY_MALE",
  profileCivilityFemale: "PROFILE_CIVILITY_FEMALE",
  member_form : {
    role: "MEMBER_FORM_ROLE",
    civility: "MEMBER_FORM_CIVILITE",
    lastname: "MEMBER_FORM_LASTNAME",
    firstname: "MEMBER_FORM_FIRSTNAME",
    address: "MEMBER_FORM_ADDRESS",
    address_label: "MEMBER_FORM_ADDRESS_LABEL",
    address_secondary: "MEMBER_FORM_ADDRESS_SECONDARY",
    code_postal: "MEMBER_FORM_CODE_POSTAL",
    city: "MEMBER_FORM_CITY",
    country: "MEMBER_FORM_COUNTRY",
    email: "MEMBER_FORM_EMAIL",
    landline: "MEMBER_FORM_LANDLINE",
    cellphone: "MEMBER_FORM_CELLPHONE",
    siret: "MEMBER_FORM_SIRET",
    code_ape: "MEMBER_FORM_CODE_APE",
    num_tva: "MEMBER_FORM_NUM_TVA",
    specialization : "MEMBER_FORM_SPECIALIZATION",
    blocks: "MEMBER_FORM_BLOCKS",
    apartments: "MEMBER_FORM_APARTMENTS",
    oldPassword: "MEMBER_FORM_OLD_PASSWORD",
    newPassword: "MEMBER_FORM_NEW_PASSWORD",
    password: "MEMBER_FORM_PASSWORD",
    entityCode: "PROFILE_ENTITY_CODE"
  },
  profileFirstSectionTitleForm: "PROFILE_FIRST_SECTION_TITLE_FORM",
  profileSecondSectionTitleForm: "PROFILE_SECOND_SECTION_TITLE_FORM",
  profileThirdSectionTitleForm: "PROFILE_THIRD_SECTION_TITLE_FORM",
  profileUserSecondSectionTitleForm: "PROFILE_USER_SECOND_SECTION_TITLE_FORM",
  profileFilterBy: "PROFILE_FILTER_BY",
  profileFilterFieldLabel: "PROFILE_FILTER_FIELD_LABEL",
  profileTableNoData: "PROFILE_TABLE_NO_DATA",
  profileTeamManagementBtn: "PROFILE_TEAM_MANAGEMENT_BTN",
  profileAgencyManagementBtn: "PROFILE_AGENCY_MANAGEMENT_BTN",
  profileTeamManagement: "PROFILE_TEAM_MANAGEMENT",
  profileCharacterProblem: "PROFILE_CHARACTER_PROBLEM",
  profileTicketClosingReason: "PROFILE_TICKET_CLOSING_REASON",
  profileAttachmentType: "PROFILE_ATTACHMENT_TYPE",
  profileTeamManagementOther: "PROFILE_TEAM_MANAGEMENT_OTHER",
  profileDeleteMessage: "PROFILE_DELETE_MESSAGE",
  profileDeleteSelectionMessage: "PROFILE_DELETE_SELECTION_MESSAGE",
  profileEdit: "PROFILE_EDIT",
  profileDelete: "PROFILE_DELETE",
  profileDeleteSelection: "PROFILE_DELETE_SELECTION",
  profileView: "PROFILE_VIEW",
  profileEditMember: "PROFILE_EDIT_MEMBER",
  profileDeleteMember: "PROFILE_DELETE_MEMBER",
  profileAddSignatureLabel: "PROFILE_ADD_SIGNATURE_LABEL",
  profileAddSignature: "PROFILE_ADD_SIGNATURE",
  memberCompany: "MEMBER_COMPANY",
  profileTemplates: "PROFILE_TEMPLATES",
  deleteMembreConfirmMessage: "DELETE_MEMEBRE_CONFIRM_MSG",
  deleteMembreModalTitle: "DELETE_MEMEBRE_MODAL_TITLE",
  closingReasonCreateTitle : "CLOSING_REASON_CREATE_TITLE",
  closingReasonEditTitle : "CLOSING_REASON_EDIT_TITLE",
  closingReasonName: "CLOSING_REASON_NAME",
  closingReasonDescription: "CLOSING_REASON_DESCRIPTION",
  ticketSubstatusMenu: "TICKET_SUBSTATUS_MENU",
  ticketSubstatusCreateTitle : "TICKET_SUBSTATUS_CREATE_TITLE",
  ticketSubstatusEditTitle : "TICKET_SUBSTATUS_EDIT_TITLE",
  ticketSubstatusName: "TICKET_SUBSTATUS_NAME",
  profileTicketReasonsMenu:'PROFILE_TICKET_REASONS_MENU',
  profileTicketReasonsDisabled:'PROFILE_TICKET_REASONS_DISABLED',
  ticketReasonCreateTitle : "TICKET_REASON_CREATE_TITLE",
  ticketReasonEditTitle : "TICKET_REASON_EDIT_TITLE",
  ticketReasonName : "TICKET_REASON_NAME",
}



// WEBPACK FOOTER //
// ./src/locales/profile/index.ts